/**
 * Google Authenticator 마이그레이션 QR 처리 (PR7 #1514)
 * googleCsvImporter 와 동형 — 파싱/변환만 수행(순환 참조 방지), 실행은 V2Modal 이 담당.
 * template 은 여기서 넣지 않는다 — 실행부(ImportV2Modal index)가 default 템플릿을
 * 일괄 주입하는 기존 관례를 따른다.
 */
import { decodeMigrationUri } from 'services/totp/googleMigration'

const buildTitle = ({ issuer, name }) => {
  if (issuer && name) return `${issuer} (${name})`
  return issuer || name || 'TOTP'
}

/**
 * 누적된 otpauth-migration URI 들(다중 QR)을 import records 로 변환.
 * @returns {{ type: 'googleauth'|'empty'|'error', records?: Array, skippedRows?: Array }}
 */
const parseGoogleAuthUris = (uris) => {
  if (!Array.isArray(uris) || uris.length === 0) return { type: 'empty' }

  const records = []
  const skippedRows = []

  try {
    uris.forEach((uri) => {
      const { accounts } = decodeMigrationUri(uri)
      accounts.forEach((account) => {
        if (account.skipped) {
          skippedRows.push({ title: buildTitle(account), reason: account.skipped })
          return
        }
        records.push({
          title: buildTitle(account),
          items: [
            {
              type: 'totp',
              label: 'TOTP',
              content: account.otpauthUri,
              encrypt: true,
              custom: true,
              required: false,
              order: 0,
              // 검증 스텝(validateCsvRecords)은 item.uiType 을 우선 사용 — PR10 에서
              // totp 가 정식 타입으로 승격(base32/URI 검증)되어 동기 갱신
              uiType: 'totp',
            },
          ],
        })
      })
    })
  } catch (e) {
    return { type: 'error' }
  }

  if (records.length === 0) return { type: 'empty', skippedRows }
  return { type: 'googleauth', records, skippedRows }
}

export default parseGoogleAuthUris
